import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface PiecesAiManualFallbackDialogData {
  reason?: string;
  offerBuyCoins?: boolean;
}

@Component({
  selector: "app-pieces-ai-manual-fallback-dialog",
  template: `
    <div class="fallback-dialog">
      <h2 class="fallback-title">Add details yourself</h2>
      <p class="fallback-message">
        {{ data?.reason || "AI could not generate step titles and descriptions." }}
      </p>
      <p class="fallback-hint">
        Your videos are still uploaded. Open each step and add a title and description
        yourself so you can continue reviewing and publishing.
      </p>
      <div class="fallback-actions">
        <button
          type="button"
          class="btn-secondary"
          *ngIf="data?.offerBuyCoins"
          (click)="buyCoins()"
        >
          Buy coins
        </button>
        <button type="button" class="btn-primary" (click)="continueManual()">
          I'll add details myself
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .fallback-dialog {
        padding: 1.5rem;
        max-width: 440px;
        text-align: left;
      }
      .fallback-title {
        margin: 0 0 0.75rem;
        font-size: 1.2rem;
        font-weight: 700;
        color: #111827;
      }
      .fallback-message,
      .fallback-hint {
        margin: 0 0 0.85rem;
        color: #374151;
        line-height: 1.5;
      }
      .fallback-hint {
        color: #6b7280;
        font-size: 0.9rem;
      }
      .fallback-actions {
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: 0.75rem;
        margin-top: 1.25rem;
      }
      .btn-primary,
      .btn-secondary {
        border: none;
        border-radius: 8px;
        padding: 0.625rem 1rem;
        font-weight: 600;
        cursor: pointer;
      }
      .btn-primary {
        background: #5ea1d8;
        color: #fff;
      }
      .btn-secondary {
        background: #f3f4f6;
        color: #374151;
      }
    `,
  ],
})
export class PiecesAiManualFallbackDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PiecesAiManualFallbackDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PiecesAiManualFallbackDialogData
  ) {}

  continueManual(): void {
    this.dialogRef.close({ action: "manual" });
  }

  buyCoins(): void {
    this.dialogRef.close({ action: "buy-coins" });
  }
}
